import React from 'react';
import { Tabs } from 'antd';
import * as TabCards from './tabList';
import { useTranslate } from 'Translate';

export default (props) => {
  const { setActiveTab, oneTab, searchParams } = props;
  const defaultActive = searchParams?.get('t');
  const i18n = useTranslate();
  const { t } = i18n;

  const tabs = [
    {
      name: t("System.entity"),
      Comp: 'Detail',
    },
    {
      name: t("General.collabs"),
      Comp: 'User',
    },
    {
      name: t("General.setting"),
      Comp: 'Setting',
    },
    {
      name: t("System.kds"),
      Comp: 'Kds',
    },
    {
      name: t("Delete.kitchen_queue_alert"),
      Comp: 'KitchenQueueAlert',
    },
    {
      name: t("System.ads"),
      Comp: 'Ads',
    },
    {
      name: t("Menu.e_invoice"),
      Comp: 'Einvoice',
    },
  ];

  return (
    <Tabs items={
        (oneTab ? [tabs[0]] : tabs).map((item, index) => {
          const Cardi = TabCards[item.Comp];
          return {
            key: (index + 1).toString(),
            label: item.name,
            forceRender: true,
            children: <Cardi {...props} />
          }
        })
    } defaultActiveKey={defaultActive || "1"} onChange={(activeKey) => setActiveTab(activeKey)}/>
  );
};
